import React from 'react';
import PropTypes from 'prop-types';
import { section } from '../decorators';

class FacilityUnits extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children } = this.props;
    const [facilityUnits] = React.Children.toArray(children);

    return facilityUnits;
  }
}

export default section(
  { name: 'Facility Units: Units Table', category: 'Unit Displays' },
  {
    subsections: [
      {
        accepts: [
          'FacilityUnitsOne',
          'FacilityUnitsTwo',
          'FacilityUnitsThree',
          'PromotionBanner',
        ],
      },
    ],
    defaults: [
      ['FacilityUnitsOne'],
    ],
  },
)(FacilityUnits);
